export default "__VITE_ASSET__DDS9Iz9D__"